import { render } from "./OptionsLocation.vue?vue&type=template&id=84b458f4"
import script from "./OptionsLocation.vue?vue&type=script&lang=js"
export * from "./OptionsLocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__